<script setup>
import { format, parse } from '@formkit/tempo'
const props = defineProps({
	featured: {
		type: Boolean,
		default: false,
	},
	right: {
		type: Boolean,
		default: false,
	},
	article: {
		Object,
	},
})
</script>

<template>
	<router-link :to="{ name: 'article', params: { slug: article.slug } }" :class="['group grid grid-cols-2 gap-5', { '!grid-cols-1': featured }]">
		<div class="relative h-fit">
			<img class="absolute left-2 top-2 z-10 w-6 transition-all duration-200 group-hover:left-4 group-hover:top-4" src="https://cdn.papercrowns.com/website/images/elements/accents/frame-accent_tl.svg" alt="" />
			<div class="relative transition-transform duration-200 ease-in-out group-hover:-rotate-2">
				<div class="absolute right-2 top-2 z-10 flex h-14 w-14 flex-col items-center justify-center bg-crowns-off-black">
					<span class="-mt-2 font-cabazon text-4xl">{{ format(article.published_at, 'DD') }}</span>
					<span class="-mt-1 text-xs">{{ format(article.published_at, 'MMM') }} '{{ format(article.published_at, 'YY') }}</span>
				</div>
				<img :class="['aspect-square h-full w-full object-cover brightness-40 grayscale transition-all duration-500 ease-in-out group-hover:brightness-100 group-hover:grayscale-0', { '!h-96': featured }]" :src="featured ? article.image : (article.image_square ?? article.image)" :alt="`${article.title} Thumbnail`" />
			</div>
			<img class="absolute bottom-2 right-2 z-10 w-6 transition-all duration-200 group-hover:bottom-4 group-hover:right-4" src="https://cdn.papercrowns.com/website/images/elements/accents/frame-accent_br.svg" alt="" />
		</div>
		<div :class="['flex h-full flex-col justify-between text-start', { 'order-first': featured || !right }]">
			<div class="relative flex flex-col items-start gap-3 overflow-hidden pb-5 uppercase">
				<span class="text-sm font-semibold text-crowns-castle-stone">{{ article.category.name }}</span>
				<span :class="['line-clamp-4 font-alternate-gothic text-4xl leading-[.9] 3xl:text-4.5xl', { '!text-5xl xl:!text-6xl': featured }]">{{ article.title }}</span>
				<img class="absolute -left-full bottom-0 opacity-0 transition-all duration-500 ease-in-out group-hover:left-0 group-hover:opacity-100" src="https://cdn.papercrowns.com/website/images/elements/accents/hr-long.svg" alt="" />
			</div>
			<p class="line-clamp-4 transition-colors duration-500 group-hover:text-crowns-clouds" v-if="!featured">{{ article.excerpt }}</p>
		</div>
		<div class="order-last">
			<p class="text-start transition-colors duration-500 group-hover:text-crowns-clouds" v-if="featured">{{ article.excerpt }}</p>
		</div>
	</router-link>
</template>
